import { Box, Grid, Typography } from "@mui/material";
import MatchTable from "./MatchTable";
import { intArray } from "./utils";

export default function KnockOutRound(props) {
    const { stage, heading } = { ...props }
    let size, md = 6, lg = 3;
    switch (stage) {
        case "R32":
            size = 16;
            break;
        case "R16":
            size = 8;
            break;
        case "QF":
            size = 4;
            break;
        case "SF":
            size = 2;
            lg = 6;
            break;
        case "3":
        case "F":
            size = 1;
            md = 12;
            lg = 12;
            break;
        default:
            size = 0;
    }
    return <Box width="100%">
        <Typography margin="8px" fontSize="1.2em" fontWeight="bold" variant="h3">
            {heading}
        </Typography>
        <Grid container spacing={2}>
            {intArray(size).map(i =>
                <Grid
                    item
                    xs={12}
                    md={md}
                    lg={lg}
                    key={i}>
                    <MatchTable
                        stage={stage}
                        matchIndex={i}
                        key={i}
                    />
                </Grid>
            )}
        </Grid>
    </Box>;
}